module.exports = __webpack_public_path__ + "9f24856b14835e05c1ecfdaf862cc773.ttf";